import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { IRevisionCheckpoint } from '../../../../core/interfaces/workflow.interface';



@Component({
  selector: 'gen-revise-option',
  templateUrl: './revise-option.component.html',
  styleUrls: ['./revise-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviseOptionComponent implements OnInit {
  public automationClass: string;
  @Input() reviseOption: IRevisionCheckpoint;

  constructor() { }

  ngOnInit() {
    this.automationClass = `Auto_ReviseOption_${this.reviseOption.display.split(' ').join('_')}`;
  }



}
